// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================================
   Volleyball Score Tracker — design tokens
   Light + dark from \`body.night-mode\`. Components use --vb-* vars.
   ============================================================ */

:root {
  --vb-font: 'Plus Jakarta Sans', system-ui, -apple-system, sans-serif;
  --vb-font-score: 'Barlow Condensed', 'Arial Narrow', sans-serif;

  /* Brand — court orange on navy */
  --vb-navy: #0b1d36;
  --vb-navy-soft: #14304f;
  --vb-primary: #ea580c;
  --vb-primary-hover: #c2410c;
  --vb-primary-contrast: #ffffff;
  --vb-primary-soft: rgba(234, 88, 12, 0.14);
  --vb-gradient: linear-gradient(135deg, #ea580c 0%, #f59e0b 100%);
  --vb-gradient-accent: linear-gradient(135deg, #0b1d36 0%, #1d4ed8 100%);
  --vb-hero: linear-gradient(160deg, #071525 0%, #0f2744 48%, #1e3a8a 100%);

  /* Team identity */
  --vb-team-a: #e11d48;
  --vb-team-a-deep: #9f1239;
  --vb-team-b: #2563eb;
  --vb-team-b-deep: #1e40af;
  --vb-serve: #fbbf24;

  /* Status */
  --vb-success: #16a34a;
  --vb-success-soft: rgba(22, 163, 74, 0.12);
  --vb-danger: #dc2626;
  --vb-danger-soft: rgba(220, 38, 38, 0.12);
  --vb-warning: #f59e0b;
  --vb-warning-soft: rgba(245, 158, 11, 0.15);

  /* Surfaces & text */
  --vb-bg: #eef1f6;
  --vb-surface: #ffffff;
  --vb-surface-2: #f8fafc;
  --vb-surface-hover: #f1f5f9;
  --vb-text: #0f172a;
  --vb-text-muted: #64748b;
  --vb-border: #e2e8f0;
  --vb-border-strong: #cbd5e1;

  /* Elevation */
  --vb-shadow-sm: 0 1px 2px rgba(15, 23, 42, 0.06);
  --vb-shadow: 0 8px 24px rgba(15, 23, 42, 0.08);
  --vb-shadow-lg: 0 18px 48px rgba(15, 23, 42, 0.14);
  --vb-shadow-glow: 0 12px 40px rgba(234, 88, 12, 0.22);

  /* Radii */
  --vb-radius-sm: 10px;
  --vb-radius: 16px;
  --vb-radius-lg: 24px;
  --vb-radius-pill: 999px;

  /* Spacing */
  --vb-space-1: 4px;
  --vb-space-2: 8px;
  --vb-space-3: 12px;
  --vb-space-4: 16px;
  --vb-space-5: 24px;
  --vb-space-6: 32px;

  --vb-transition: 0.2s ease;
  --vb-tap: 44px;
}

body.night-mode {
  --vb-primary: #fb923c;
  --vb-primary-hover: #fdba74;
  --vb-primary-contrast: #0b1d36;
  --vb-primary-soft: rgba(251, 146, 60, 0.18);

  --vb-success: #22c55e;
  --vb-success-soft: rgba(34, 197, 94, 0.18);
  --vb-danger: #f87171;
  --vb-danger-soft: rgba(248, 113, 113, 0.18);
  --vb-warning: #fbbf24;
  --vb-warning-soft: rgba(251, 191, 36, 0.18);

  --vb-bg: #070d18;
  --vb-surface: #111827;
  --vb-surface-2: #0f172a;
  --vb-surface-hover: #1e293b;
  --vb-text: #f1f5f9;
  --vb-text-muted: #94a3b8;
  --vb-border: #1e293b;
  --vb-border-strong: #334155;

  --vb-shadow-sm: 0 1px 2px rgba(0, 0, 0, 0.4);
  --vb-shadow: 0 8px 24px rgba(0, 0, 0, 0.45);
  --vb-shadow-lg: 0 18px 48px rgba(0, 0, 0, 0.55);
}

/* ---- Reusable primitives ---- */

.vb-page {
  padding: var(--vb-space-4);
  max-width: 1200px;
  margin: 0 auto;
  min-height: 100vh;
  box-sizing: border-box;
  color: var(--vb-text);
}

.vb-card {
  background: var(--vb-surface);
  border: 1px solid var(--vb-border);
  border-radius: var(--vb-radius);
  box-shadow: var(--vb-shadow-sm);
  transition: transform var(--vb-transition), box-shadow var(--vb-transition);
}

.vb-card-hover:hover {
  transform: translateY(-2px);
  box-shadow: var(--vb-shadow);
}

.vb-page-header {
  display: flex;
  flex-direction: column;
  gap: var(--vb-space-3);
  margin-bottom: var(--vb-space-5);
}

.vb-page-header h1 {
  display: flex;
  align-items: center;
  gap: var(--vb-space-2);
  margin: 0;
  font-size: 22px;
  font-weight: 800;
  letter-spacing: -0.02em;
  text-transform: none;
  color: var(--vb-text);
  text-align: left;
}

.vb-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: var(--vb-space-2);
  min-height: var(--vb-tap);
  padding: 10px 16px;
  border: 1px solid transparent;
  border-radius: var(--vb-radius-sm);
  font-family: inherit;
  font-size: 14px;
  font-weight: 650;
  cursor: pointer;
  transition: background var(--vb-transition), border-color var(--vb-transition), transform var(--vb-transition), box-shadow var(--vb-transition);
  margin: 0;
  min-width: 0;
}

.vb-btn:active { transform: scale(0.97); }

.vb-btn-primary {
  background: var(--vb-primary);
  color: var(--vb-primary-contrast);
  box-shadow: 0 6px 16px rgba(234, 88, 12, 0.28);
}
.vb-btn-primary:hover { background: var(--vb-primary-hover); }

.vb-btn-ghost {
  background: var(--vb-surface);
  border-color: var(--vb-border);
  color: var(--vb-text);
}
.vb-btn-ghost:hover { background: var(--vb-surface-hover); }

.vb-input,
.vb-select,
.vb-textarea {
  width: 100%;
  box-sizing: border-box;
  min-height: var(--vb-tap);
  padding: 12px 14px;
  border: 1px solid var(--vb-border-strong);
  border-radius: var(--vb-radius-sm);
  background: var(--vb-surface);
  color: var(--vb-text);
  font-family: inherit;
  font-size: 16px;
  transition: border-color var(--vb-transition), box-shadow var(--vb-transition);
}

.vb-input:focus,
.vb-select:focus,
.vb-textarea:focus {
  outline: none;
  border-color: var(--vb-primary);
  box-shadow: 0 0 0 3px var(--vb-primary-soft);
}

.vb-label {
  display: block;
  margin-bottom: 6px;
  font-size: 13px;
  font-weight: 650;
  color: var(--vb-text-muted);
}

.vb-logo {
  display: grid;
  place-items: center;
  width: 36px;
  height: 36px;
  border-radius: 10px;
  background: var(--vb-navy);
  color: #fff;
  font-size: 18px;
  box-shadow: none;
  flex-shrink: 0;
}

.custom-tooltip {
  background: var(--vb-surface);
  border: 1px solid var(--vb-border);
  border-radius: 10px;
  padding: 10px 12px;
  box-shadow: var(--vb-shadow);
  color: var(--vb-text);
}

/* Neutralize the legacy global \`button { min-width:100px; margin:5px }\`
   default inside redesigned screens so icon buttons stay compact. */
.statistics button,
.team-management button,
.match-grouping button,
.match-display button,
.offline-status button,
.scoreboard-container button,
.auth-container button,
.user-profile button,
.forgot-password-container button,
.shared-match-container button {
  margin: 0;
  min-width: 0;
}

@media (min-width: 640px) {
  .vb-page { padding: var(--vb-space-5); }
  .vb-page-header {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }
  .vb-page-header h1 { font-size: 28px; }
}

@media (prefers-reduced-motion: reduce) {
  *, *::before, *::after {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/theme.css"],"names":[],"mappings":"AAAA;;;iEAGiE;;AAEjE;EACE,oEAAoE;EACpE,+DAA+D;;EAE/D,iCAAiC;EACjC,kBAAkB;EAClB,uBAAuB;EACvB,qBAAqB;EACrB,2BAA2B;EAC3B,8BAA8B;EAC9B,0CAA0C;EAC1C,gEAAgE;EAChE,uEAAuE;EACvE,yEAAyE;;EAEzE,kBAAkB;EAClB,oBAAoB;EACpB,yBAAyB;EACzB,oBAAoB;EACpB,yBAAyB;EACzB,mBAAmB;;EAEnB,WAAW;EACX,qBAAqB;EACrB,0CAA0C;EAC1C,oBAAoB;EACpB,yCAAyC;EACzC,qBAAqB;EACrB,2CAA2C;;EAE3C,oBAAoB;EACpB,gBAAgB;EAChB,qBAAqB;EACrB,uBAAuB;EACvB,2BAA2B;EAC3B,kBAAkB;EAClB,wBAAwB;EACxB,oBAAoB;EACpB,2BAA2B;;EAE3B,cAAc;EACd,gDAAgD;EAChD,8CAA8C;EAC9C,kDAAkD;EAClD,qDAAqD;;EAErD,UAAU;EACV,oBAAoB;EACpB,iBAAiB;EACjB,oBAAoB;EACpB,uBAAuB;;EAEvB,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;;EAElB,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,8BAA8B;EAC9B,2CAA2C;;EAE3C,qBAAqB;EACrB,0CAA0C;EAC1C,oBAAoB;EACpB,2CAA2C;EAC3C,qBAAqB;EACrB,2CAA2C;;EAE3C,gBAAgB;EAChB,qBAAqB;EACrB,uBAAuB;EACvB,2BAA2B;EAC3B,kBAAkB;EAClB,wBAAwB;EACxB,oBAAoB;EACpB,2BAA2B;;EAE3B,4CAA4C;EAC5C,2CAA2C;EAC3C,+CAA+C;AACjD;;AAEA,kCAAkC;;AAElC;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;EAC7B,kCAAkC;EAClC,+BAA+B;EAC/B,+BAA+B;EAC/B,2EAA2E;AAC7E;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;EACpB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,6BAA6B;EAC7B,kCAAkC;EAClC,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,+IAA+I;EAC/I,SAAS;EACT,YAAY;AACd;;AAEA,iBAAiB,sBAAsB,EAAE;;AAEzC;EACE,6BAA6B;EAC7B,iCAAiC;EACjC,8CAA8C;AAChD;AACA,wBAAwB,mCAAmC,EAAE;;AAE7D;EACE,6BAA6B;EAC7B,8BAA8B;EAC9B,qBAAqB;AACvB;AACA,sBAAsB,mCAAmC,EAAE;;AAE3D;;;EAGE,WAAW;EACX,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,yCAAyC;EACzC,kCAAkC;EAClC,6BAA6B;EAC7B,qBAAqB;EACrB,oBAAoB;EACpB,eAAe;EACf,8EAA8E;AAChF;;AAEA;;;EAGE,aAAa;EACb,+BAA+B;EAC/B,4CAA4C;AAC9C;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,0BAA0B;EAC1B,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,kCAAkC;EAClC,mBAAmB;EACnB,kBAAkB;EAClB,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;oEACoE;AACpE;;;;;;;;;;EAUE,SAAS;EACT,YAAY;AACd;;AAEA;EACE,WAAW,0BAA0B,EAAE;EACvC;IACE,mBAAmB;IACnB,mBAAmB;IACnB,8BAA8B;EAChC;EACA,qBAAqB,eAAe,EAAE;AACxC;;AAEA;EACE;IACE,qCAAqC;IACrC,uCAAuC;IACvC,sCAAsC;EACxC;AACF","sourcesContent":["/* ============================================================\n   Volleyball Score Tracker — design tokens\n   Light + dark from `body.night-mode`. Components use --vb-* vars.\n   ============================================================ */\n\n:root {\n  --vb-font: 'Plus Jakarta Sans', system-ui, -apple-system, sans-serif;\n  --vb-font-score: 'Barlow Condensed', 'Arial Narrow', sans-serif;\n\n  /* Brand — court orange on navy */\n  --vb-navy: #0b1d36;\n  --vb-navy-soft: #14304f;\n  --vb-primary: #ea580c;\n  --vb-primary-hover: #c2410c;\n  --vb-primary-contrast: #ffffff;\n  --vb-primary-soft: rgba(234, 88, 12, 0.14);\n  --vb-gradient: linear-gradient(135deg, #ea580c 0%, #f59e0b 100%);\n  --vb-gradient-accent: linear-gradient(135deg, #0b1d36 0%, #1d4ed8 100%);\n  --vb-hero: linear-gradient(160deg, #071525 0%, #0f2744 48%, #1e3a8a 100%);\n\n  /* Team identity */\n  --vb-team-a: #e11d48;\n  --vb-team-a-deep: #9f1239;\n  --vb-team-b: #2563eb;\n  --vb-team-b-deep: #1e40af;\n  --vb-serve: #fbbf24;\n\n  /* Status */\n  --vb-success: #16a34a;\n  --vb-success-soft: rgba(22, 163, 74, 0.12);\n  --vb-danger: #dc2626;\n  --vb-danger-soft: rgba(220, 38, 38, 0.12);\n  --vb-warning: #f59e0b;\n  --vb-warning-soft: rgba(245, 158, 11, 0.15);\n\n  /* Surfaces & text */\n  --vb-bg: #eef1f6;\n  --vb-surface: #ffffff;\n  --vb-surface-2: #f8fafc;\n  --vb-surface-hover: #f1f5f9;\n  --vb-text: #0f172a;\n  --vb-text-muted: #64748b;\n  --vb-border: #e2e8f0;\n  --vb-border-strong: #cbd5e1;\n\n  /* Elevation */\n  --vb-shadow-sm: 0 1px 2px rgba(15, 23, 42, 0.06);\n  --vb-shadow: 0 8px 24px rgba(15, 23, 42, 0.08);\n  --vb-shadow-lg: 0 18px 48px rgba(15, 23, 42, 0.14);\n  --vb-shadow-glow: 0 12px 40px rgba(234, 88, 12, 0.22);\n\n  /* Radii */\n  --vb-radius-sm: 10px;\n  --vb-radius: 16px;\n  --vb-radius-lg: 24px;\n  --vb-radius-pill: 999px;\n\n  /* Spacing */\n  --vb-space-1: 4px;\n  --vb-space-2: 8px;\n  --vb-space-3: 12px;\n  --vb-space-4: 16px;\n  --vb-space-5: 24px;\n  --vb-space-6: 32px;\n\n  --vb-transition: 0.2s ease;\n  --vb-tap: 44px;\n}\n\nbody.night-mode {\n  --vb-primary: #fb923c;\n  --vb-primary-hover: #fdba74;\n  --vb-primary-contrast: #0b1d36;\n  --vb-primary-soft: rgba(251, 146, 60, 0.18);\n\n  --vb-success: #22c55e;\n  --vb-success-soft: rgba(34, 197, 94, 0.18);\n  --vb-danger: #f87171;\n  --vb-danger-soft: rgba(248, 113, 113, 0.18);\n  --vb-warning: #fbbf24;\n  --vb-warning-soft: rgba(251, 191, 36, 0.18);\n\n  --vb-bg: #070d18;\n  --vb-surface: #111827;\n  --vb-surface-2: #0f172a;\n  --vb-surface-hover: #1e293b;\n  --vb-text: #f1f5f9;\n  --vb-text-muted: #94a3b8;\n  --vb-border: #1e293b;\n  --vb-border-strong: #334155;\n\n  --vb-shadow-sm: 0 1px 2px rgba(0, 0, 0, 0.4);\n  --vb-shadow: 0 8px 24px rgba(0, 0, 0, 0.45);\n  --vb-shadow-lg: 0 18px 48px rgba(0, 0, 0, 0.55);\n}\n\n/* ---- Reusable primitives ---- */\n\n.vb-page {\n  padding: var(--vb-space-4);\n  max-width: 1200px;\n  margin: 0 auto;\n  min-height: 100vh;\n  box-sizing: border-box;\n  color: var(--vb-text);\n}\n\n.vb-card {\n  background: var(--vb-surface);\n  border: 1px solid var(--vb-border);\n  border-radius: var(--vb-radius);\n  box-shadow: var(--vb-shadow-sm);\n  transition: transform var(--vb-transition), box-shadow var(--vb-transition);\n}\n\n.vb-card-hover:hover {\n  transform: translateY(-2px);\n  box-shadow: var(--vb-shadow);\n}\n\n.vb-page-header {\n  display: flex;\n  flex-direction: column;\n  gap: var(--vb-space-3);\n  margin-bottom: var(--vb-space-5);\n}\n\n.vb-page-header h1 {\n  display: flex;\n  align-items: center;\n  gap: var(--vb-space-2);\n  margin: 0;\n  font-size: 22px;\n  font-weight: 800;\n  letter-spacing: -0.02em;\n  text-transform: none;\n  color: var(--vb-text);\n  text-align: left;\n}\n\n.vb-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: var(--vb-space-2);\n  min-height: var(--vb-tap);\n  padding: 10px 16px;\n  border: 1px solid transparent;\n  border-radius: var(--vb-radius-sm);\n  font-family: inherit;\n  font-size: 14px;\n  font-weight: 650;\n  cursor: pointer;\n  transition: background var(--vb-transition), border-color var(--vb-transition), transform var(--vb-transition), box-shadow var(--vb-transition);\n  margin: 0;\n  min-width: 0;\n}\n\n.vb-btn:active { transform: scale(0.97); }\n\n.vb-btn-primary {\n  background: var(--vb-primary);\n  color: var(--vb-primary-contrast);\n  box-shadow: 0 6px 16px rgba(234, 88, 12, 0.28);\n}\n.vb-btn-primary:hover { background: var(--vb-primary-hover); }\n\n.vb-btn-ghost {\n  background: var(--vb-surface);\n  border-color: var(--vb-border);\n  color: var(--vb-text);\n}\n.vb-btn-ghost:hover { background: var(--vb-surface-hover); }\n\n.vb-input,\n.vb-select,\n.vb-textarea {\n  width: 100%;\n  box-sizing: border-box;\n  min-height: var(--vb-tap);\n  padding: 12px 14px;\n  border: 1px solid var(--vb-border-strong);\n  border-radius: var(--vb-radius-sm);\n  background: var(--vb-surface);\n  color: var(--vb-text);\n  font-family: inherit;\n  font-size: 16px;\n  transition: border-color var(--vb-transition), box-shadow var(--vb-transition);\n}\n\n.vb-input:focus,\n.vb-select:focus,\n.vb-textarea:focus {\n  outline: none;\n  border-color: var(--vb-primary);\n  box-shadow: 0 0 0 3px var(--vb-primary-soft);\n}\n\n.vb-label {\n  display: block;\n  margin-bottom: 6px;\n  font-size: 13px;\n  font-weight: 650;\n  color: var(--vb-text-muted);\n}\n\n.vb-logo {\n  display: grid;\n  place-items: center;\n  width: 36px;\n  height: 36px;\n  border-radius: 10px;\n  background: var(--vb-navy);\n  color: #fff;\n  font-size: 18px;\n  box-shadow: none;\n  flex-shrink: 0;\n}\n\n.custom-tooltip {\n  background: var(--vb-surface);\n  border: 1px solid var(--vb-border);\n  border-radius: 10px;\n  padding: 10px 12px;\n  box-shadow: var(--vb-shadow);\n  color: var(--vb-text);\n}\n\n/* Neutralize the legacy global `button { min-width:100px; margin:5px }`\n   default inside redesigned screens so icon buttons stay compact. */\n.statistics button,\n.team-management button,\n.match-grouping button,\n.match-display button,\n.offline-status button,\n.scoreboard-container button,\n.auth-container button,\n.user-profile button,\n.forgot-password-container button,\n.shared-match-container button {\n  margin: 0;\n  min-width: 0;\n}\n\n@media (min-width: 640px) {\n  .vb-page { padding: var(--vb-space-5); }\n  .vb-page-header {\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n  }\n  .vb-page-header h1 { font-size: 28px; }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  *, *::before, *::after {\n    animation-duration: 0.01ms !important;\n    animation-iteration-count: 1 !important;\n    transition-duration: 0.01ms !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
